// extracted by mini-css-extract-plugin
module.exports = {"banner":"video-overlay_banner__3RhDv","banner-video":"video-overlay_banner-video__1YUSh"};